import React from 'react';

export default class UnAuthenticatedLayout extends React.Component {
    render() {
        return (
            <div>
                {this.props.children}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./app/layout/UnAuthenticatedLayout.js